import { ref } from 'ember-ref-bucket';

import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

import type AppNavState from 'volta/services/app-nav-state';

export interface IArgs {
  /** Hint text to display */
  placeholder?: string;
  /** Force the focus state on the input */
  focused?: boolean;
  /** Force a state where search is active but the text field component is not focused */
  active?: boolean;
  /** Callback when input is focused */
  onFocus?(): void;
  /** Callback when focus is removed */
  onBlur?(): void;
  /** Callback when search field cancel button is clicked */
  onCancel?(): void;
}

export default class BvAppSearchField extends Component<IArgs> {
  @service appNavState!: AppNavState;

  @ref('inputNode')
  inputNode: HTMLInputElement | null = null;

  searchId = `${guidFor(this)}BvAppSearchField`;

  searchKeyLabel = navigator.platform.indexOf('Mac') > -1 ? '⌘K' : 'Ctrl+K';

  @action
  focusOut() {
    this.cleanInput('blur');
    this.appNavState.closeSearch();
  }

  @action
  blurInput(e: KeyboardEvent) {
    e.preventDefault();
    if (!this.args.focused) {
      this.cleanInput('blur');
    }
  }

  @action
  handleClear() {
    this.args.onCancel?.();
    this.cleanInput('focus');
  }

  @action
  handleSearch(event?: InputEvent) {
    if(!event) {
      return;
    }
      const { currentTarget } = event;
      this.appNavState.searchText = (currentTarget as HTMLInputElement)?.value ?? '';
  }

  private cleanInput(method: 'focus' | 'blur') {
    if (this.inputNode !== null) {
      this.inputNode.value = '';
      this.appNavState.searchText = '';
      this.inputNode[method]();
    }
  }
}
